var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vcenter"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":_vm.color,"disabled":_vm.disabled},on:{"click":_vm.goto_qunit}},[_vm._v("\n      mdi-arrow-right\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }